import { FC } from 'react';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { Check } from 'react-feather';

import { AgreementStatus, isAgreementStatusResolved } from '../AgreementsTypes';

interface Props {
  status: AgreementStatus;
  idx: number;
}

export const AgreementIndicator: FC<Props> = ({ status, idx }) => {
  const resolved = isAgreementStatusResolved(status);

  return (
    <div className={`number-indicator ${resolved ? 'completed' : ''}`}>
      <Text variant="body-4" bold>
        {resolved ? <Check /> : `0${idx + 1}`}
      </Text>
    </div>
  );
};
